export default __webpack_public_path__ + "static/media/BEFIT ECO.66e47a32.jpg";